module.exports = __webpack_public_path__ + "static/homewebsite-133adad41fc3d123f80c5801457db1bd.png";